import {Component, EventEmitter, forwardRef, Input, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";
import {CVA} from "./cva";
import {UIFormEngineComponentMetadata} from "./form";


@Component({
    selector: 'ui-input-yes-no',
    host: {class: 'ui-input-yes-no'},
    template: `
	    <div class="ui-input-presentation " *ngIf="presentationMode">
		    {{cva.value=='Y'  || cva.value===true?'Yes':'No'}}
	    </div>

	    <ng-container *ngIf="!presentationMode">

		    <div class="" [hidden]="!presentationMode || !cva.value">
			    <div class="btn {{
				metadata.options?.colors?
					(
						cva.value=='Y' || cva.value=='N' ||     cva.value===false || cva.value===false ?
						(
                                                        cva.value=='Y' || cva.value===true?
                                                        (metadata.options.reversed?'btn-danger':'btn-success')
                                                        :
                                                        (metadata.options.reversed?'btn-success':'btn-danger')
						)
						:
						'btn-light'
					)
					:
				  (
						'btn-light'
					)
				}}">{{cva.value}}</div>
		    </div>
		    <button [hidden]="presentationMode"
			    class="btn {{cva.value=='Y' ?(metadata.options?.colors?(metadata.options.reversed?'btn-danger active':'btn-success active'):'active'):'btn-light'}}"
			    value="Yes" type="button" (click)="writeValueFromInput('Y')"
			    (dblclick)="writeValueFromInput(null)"
		    >Yes
		    </button>
		    <button [hidden]="presentationMode"
			    class="btn {{cva.value=='N' ?(metadata.options?.colors?(metadata.options.reversed?'btn-success active':'btn-danger active'):'active'):'btn-light'}}"
			    value="No" type="button" (click)="writeValueFromInput('N')"
			    (dblclick)="writeValueFromInput(null)"
		    >
			    No
		    </button>
		    <button [hidden]="!metadata.options?.na || presentationMode"
			    class="btn {{cva.value=='NA'?'active':'btn-light'}}" value="NA" type="button"
			    (click)="writeValueFromInput('NA')"
			    (dblclick)="writeValueFromInput(null)"
		    >NA
		    </button>

	    </ng-container>
    `,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => UIInputYesNoComponent),
            multi: true
        }
    ]
})
export class UIInputYesNoComponent extends CVA {
    @Input() metadata: UIFormEngineComponentMetadata;
    @Input() name;
    @Input() presentationMode = false;

    public static CHOICE_YES = 'Y';
    public static CHOICE_NO = 'N';
    public static CHOICE_NA = 'NA';

}
